// extracted by mini-css-extract-plugin
export default {"test_card":"PartWorkReport_test_card__R6iaV","btn_print":"PartWorkReport_btn_print__3Z5Ku","div_print":"PartWorkReport_div_print__LQFqe"};